import { render } from "./AlarmSettingsIndexGroups.vue?vue&type=template&id=16439b4c"
import script from "./AlarmSettingsIndexGroups.vue?vue&type=script&lang=js"
export * from "./AlarmSettingsIndexGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__